import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TFormVersionItem {
  id: number;
  version: number;
  status: string;
  basisForSending: string;
  dateSent: Date;
  regularEvaluationStatus: string;
  forPublish: string;
  datePublished: Date;
}

export interface IFormVersionItem extends TFormVersionItem {}

const FormVersionItem = Model(
  (model: TFormVersionItem): IFormVersionItem => {
    const _formVersionItem: TFormVersionItem = Object.assign({}, model);

    let create = (FormVersionItem: IFormVersionItem): IFormVersionItem => {
      let obj = ValidatableObject(FormVersionItem);
      return obj;
    };

    let FormVersionItem = {
      get id() {
        return _formVersionItem.id;
      },

      get dateSent() {
        return _formVersionItem.dateSent;
      },

      set dateSent(value: any) {
        _formVersionItem.dateSent = value;
      },

      get status() {
        return _formVersionItem.status;
      },

      get version() {
        return _formVersionItem.version;
      },

      get basisForSending() {
        return _formVersionItem.basisForSending;
      },

      get regularEvaluationStatus() {
        return _formVersionItem.regularEvaluationStatus;
      },

      get forPublish() {
        return _formVersionItem.forPublish;
      },
      get datePublished() {
        return _formVersionItem.dateSent;
      },

      set datePublished(value: any) {
        _formVersionItem.datePublished = value;
      }
    };

    return create(FormVersionItem);
  }
);

export default FormVersionItem;
